import { useRef } from "react";
import { UserPermissionTag } from "./UserPermissionTag.jsx";
import { FloatingPanel, useDismissOnOutsideClick } from "../../components/ui/FloatingPanel.jsx";

export function UserPermissionsSection({
  permissions,
  permsLoading,
  onRemove,
  addPermOpen,
  addablePermissions,
  onAdd,
  onCloseAdd,
  c,
  dark,
}) {
  const anchorRef = useRef(null);
  const panelRef = useRef(null);

  useDismissOnOutsideClick(addPermOpen, onCloseAdd, [anchorRef, panelRef]);

  const panelShadow = dark ? "0 12px 32px rgba(0,0,0,.5)" : "0 12px 32px rgba(15,23,42,.12)";

  return (
    <div style={{ marginTop: 2 }}>
      <div
        style={{
          fontSize: 10,
          fontWeight: 700,
          letterSpacing: ".08em",
          textTransform: "uppercase",
          color: c.sub,
          marginBottom: 8,
        }}
      >
        Permissions
      </div>
      <div
        style={{
          borderRadius: 10,
          border: `1px solid ${c.cardBdr}`,
          background: c.hover,
          padding: 12,
          boxShadow: dark ? "inset 0 1px 0 rgba(255,255,255,.04)" : "inset 0 1px 0 rgba(255,255,255,.8)",
        }}
      >
        <div
          ref={anchorRef}
          style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}
        >
          <span style={{ fontSize: 11.5, color: c.mid, fontWeight: 600 }}>Assigned Permissions</span>
          <span style={{ fontSize: 11, color: c.sub }}>{permissions.length} total</span>
        </div>

        <FloatingPanel anchorRef={anchorRef} panelRef={panelRef} open={addPermOpen && addablePermissions.length > 0} align="end" minWidth={300} gap={6}>
          <div
            style={{
              maxHeight: 220,
              overflow: "auto",
              background: c.card,
              border: `1px solid ${c.cardBdr}`,
              borderRadius: 10,
              boxShadow: panelShadow,
              padding: 6,
            }}
          >
            {addablePermissions.map((perm) => (
              <button
                key={perm}
                type="button"
                onClick={() => onAdd(perm)}
                style={{
                  width: "100%",
                  textAlign: "left",
                  border: "none",
                  background: "transparent",
                  borderRadius: 7,
                  padding: "9px 12px",
                  fontSize: 12,
                  color: c.text,
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = c.hover;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "transparent";
                }}
              >
                {perm}
              </button>
            ))}
          </div>
        </FloatingPanel>

        {permsLoading ? (
          <div style={{ color: c.sub, fontSize: 13, minHeight: 68 }}>Loading permissions…</div>
        ) : permissions.length === 0 ? (
          <div style={{ color: c.sub, fontSize: 13, minHeight: 68, display: "grid", placeItems: "center" }}>
            No permissions assigned
          </div>
        ) : (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8, alignContent: "flex-start", minHeight: 68 }}>
            {permissions.map((perm) => (
              <UserPermissionTag key={perm} permission={perm} onRemove={onRemove} c={c} dark={dark} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
